export const META_FIELDS_LIST = [
    'productStatuses',
    'countries',
    'brands',
    'featureFlags',
    'userPreferences',
    'vendors',
    'states',
    'serviceStatuses',
    'serviceTypes',
    'unitOfMeasurements',
    'roles',
    'permissionGroups',
    'rejectionReasons',
    'commissionStatuses',
    'commissionActions'
]
